
export default function BookingHero() {
  return (
    <section 
      className="relative h-96 bg-cover bg-center bg-no-repeat flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/e2f7e034843b3bc3fbfe769a6fa6cd13.jpg')`
      }}
    >
      <div className="text-center text-white max-w-4xl mx-auto px-4">
        <h1 className="text-5xl font-bold mb-6">Book Your Glamping Experience</h1>
        <p className="text-xl leading-relaxed">
          Reserve your luxury retreat in nature's most beautiful settings. Choose from our premium glamping accommodations and create unforgettable memories.
        </p>
      </div>
    </section>
  );
}